import React, { useState, useEffect } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import * as utils from "../../Utils/comman";
import moment from "moment";

const CreditModal = ({ show, handleClose, selectedRow }) => {
  const [page, setPage] = useState(1);
  const [historyList, setHistoryList] = useState([]);
  const countPerPage = 10;

  useEffect(() => {
    getQuotationList();
  }, [page, selectedRow]);

  const getQuotationList = () => {
    utils
      .callAPI(
        "get",
        `/sales/getCreditLimitHistoryList?id=${selectedRow}&page=${page}&per_page=${countPerPage}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setHistoryList(res.result);
        } else {
          setHistoryList([]);
        }
      })
      .catch((err) => {
        setHistoryList([]);
      });
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Credit Limit History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {historyList.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Date</th>

                  <th>Credit Limit</th>
                </tr>
              </thead>
              <tbody>
                {historyList.map((item, index) => (
                  <tr key={index}>
                    <td>{moment(item.createdAt).format("DD/MM/YYYY")}</td>

                    <td>{item.credit_limit}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <div>
              <p className="text-center mt-1 fs-4 "> No History Found</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CreditModal;
